import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { ZoneMapTab } from './ZoneMapTab';
import { ZoneSetupTab } from './ZoneSetupTab';
import { List, Map } from 'lucide-react';

type ZoneView = 'map' | 'list';

function ZoneManagementToolbar({
  view,
  setView
}: {
  view: ZoneView;
  setView: (v: ZoneView) => void;
}) {
  return (
    <div
      className={'flex min-h-[60px] items-center justify-between border-b bg-background px-4 py-3'}
    >
      <div>
        <h2 className='text-xl font-semibold'>Zone Management</h2>
        <p className='text-sm text-muted-foreground'>Manage zones and visualize boundaries</p>
      </div>

      <div className='flex items-center gap-2'>
        <div className='flex items-center rounded-md border bg-muted p-1'>
          <Button
            variant={view === 'list' ? 'default' : 'ghost'}
            size='sm'
            onClick={() => setView('list')}
            className='h-8 px-3'
          >
            <List className='mr-1 h-4 w-4' />
            List
          </Button>
          <Button
            variant={view === 'map' ? 'default' : 'ghost'}
            size='sm'
            onClick={() => setView('map')}
            className='h-8 px-3'
          >
            <Map className='mr-1 h-4 w-4' />
            Map
          </Button>
        </div>
      </div>
    </div>
  );
}

export const UnifiedZoneManagementTab: React.FC = () => {
  const [view, setView] = useState<ZoneView>('map');

  return (
    <div className='flex-1 flex flex-col min-h-0'>
      <ZoneManagementToolbar view={view} setView={setView} />

      {view === 'list' && (
        <div className='flex-1 min-h-0 overflow-y-auto'>
          <ZoneSetupTab />
        </div>
      )}

      {view === 'map' && (
        <div className='flex-1 min-h-0 overflow-hidden'>
          <ZoneMapTab />
        </div>
      )}
    </div>
  );
};
